import React, { useEffect, useState } from "react";
import { postMarca, getMarcas } from "../helpers/rutaMarcas";
import "../css/addclienteform.css";

const AddMarcaForm = ({ setShow }) => {
  const [formValues, setFormValues] = useState({
    nombre: "",
  });

  const [marcas, setMarcas] = useState({
    data: [],
    loading: true,
  });

  useEffect(() => {
    getMarcas()
      .then((resp) => {
        setMarcas({
          data: resp?.marcas || [],
          loading: false,
        });
      })
      .catch((error) => {
        console.error("Error al cargar marcas:", error);
        setMarcas({
          data: [],
          loading: false,
        });
      });
  }, []);

  const handleChange = (e) => {
    setFormValues({
      ...formValues,
      [e.target.name]: e.target.value.toUpperCase(),
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formValues.nombre.trim()) {
      alert("Debe ingresar una marca");
      return;
    }

    const payload = {
      nombre: formValues.nombre.trim().toUpperCase(),
    };

    try {
      const resp = await postMarca(payload);

      console.log("Marca guardada:", resp);

      if (resp?.ok === false) {
        alert(resp?.error || "No se pudo guardar la marca");
        return;
      }

      setFormValues({
        nombre: "",
      });

      if (typeof setShow === "function") {
        setShow(false);
      }
    } catch (error) {
      console.error("Error al guardar marca:", error);
      alert("No se pudo guardar la marca. Revisá consola / Network.");
    }
  };

  return (
    <>
      {!marcas.loading && (
        <div className="container">
          <form onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group mt-3 col-sm-6">
                <label>Marca</label>
                <input
                  type="text"
                  className="form-control"
                  name="nombre"
                  maxLength="50"
                  required
                  value={formValues.nombre}
                  onChange={handleChange}
                  placeholder="Ej: HONDA"
                />
              </div>
            </div>

            <div>
              <button
                type="submit"
                className="btn btn-dark mt-5 mb-3"
                id="button"
              >
                Guardar
              </button>
            </div>
          </form>
        </div>
      )}
    </>
  );
};

export default AddMarcaForm;